var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "card menu-bg-blue-transparent dll-container",
        class: { "card--minimized": _vm.isMinimized },
      },
      [
        _c(
          "div",
          { staticClass: "data-panel" },
          [
            _c("fa", {
              staticClass: "data-panel__minimize cursor",
              attrs: {
                icon: ["fas", _vm.isMinimized ? "caret-up" : "caret-down"],
                title: _vm.isMinimized
                  ? "Expand layer list"
                  : "Minimize layer list",
              },
              on: { click: _vm.toggleMinimize },
            }),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "mb-2", attrs: { "no-gutters": "" } },
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "button",
                    {
                      staticClass: "change-region-btn",
                      attrs: { title: "Change Dataset" },
                      on: {
                        click: function ($event) {
                          return _vm.$bvModal.show("datasetSelection")
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "change-region-icon",
                          attrs: {
                            viewBox: "0 0 16 16",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: {
                              cx: "8",
                              cy: "8",
                              r: "6.5",
                              stroke: "currentColor",
                              "stroke-width": "1.2",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M8 1.5C8 1.5 10.5 4 10.5 8S8 14.5 8 14.5M8 1.5C8 1.5 5.5 4 5.5 8S8 14.5 8 14.5M1.5 8h13",
                              stroke: "currentColor",
                              "stroke-width": "1.2",
                              "stroke-linecap": "round",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Change Dataset")]),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { staticClass: "layer-list-font" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        (_vm.customerName
                          ? _vm.customerName.substring(
                              0,
                              _vm.customerName.length - 3
                            )
                          : "") + "Delivery Review Tool"
                      ) +
                      "\n        "
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.dataset
              ? _c(
                  "b-row",
                  [
                    _c("b-col", { staticClass: "layer-list-font" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getFormattedDate(_vm.dataset.releaseDate) +
                            " - " +
                            _vm.dataset.extent
                        )
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dataset
              ? _c(
                  "b-row",
                  [
                    _c("b-col", { staticClass: "layer-list-font" }, [
                      _vm._v(_vm._s(_vm.dataset.partNumber)),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isMinimized,
                expression: "!isMinimized",
              },
            ],
            staticClass: "card-body-padding",
          },
          [
            _c(
              "div",
              { staticClass: "scroll-Container" },
              [
                _c("MMP_DLL", {
                  staticClass: "panel-height",
                  attrs: {
                    customerProjectId: _vm.customerProjectId,
                    drtLayersButtonsCtrl: _vm.drtLayersButtonsCtrl,
                    drtLayersToggle: _vm.drtLayersToggle,
                    filterClassesObj: _vm.filterClassesObj,
                    layerResponse: _vm.layerResponse,
                    map: _vm.map,
                    mmp_layersObj: _vm.mmp_layersObj,
                    otonomoSubcountry: _vm.otonomoSubcountry,
                    rules: _vm.rules,
                    selectAllControl: _vm.selectAllControl,
                    showDRTLayers: _vm.showDRTLayers,
                    spinnerManager: _vm.spinnerManager,
                    zoomEnded: _vm.zoomEnded,
                    zoomLevelCap: _vm.zoomLevelCap,
                    showLidarPanel: _vm.showLidarPanel,
                    baseMapsOpen: _vm.baseMapsOpen,
                    extentsOpen: _vm.extentsOpen,
                    user: _vm.user,
                  },
                  on: {
                    removeLayerListener: function ($event) {
                      return _vm.$emit("removeLayerListener")
                    },
                    getErrorsLayer: function ($event) {
                      return _vm.$emit("getErrorsLayer", $event)
                    },
                    getFilterModal: function ($event) {
                      return _vm.getFilterModal($event.layer, $event.id)
                    },
                    getLegend: function ($event) {
                      return _vm.$emit("getLegend", $event)
                    },
                    getShowAttributes: function ($event) {
                      return _vm.$emit("getShowAttributes", $event)
                    },
                    layerButtonsChanged: function ($event) {
                      return _vm.$emit("layerButtonsChanged", $event)
                    },
                    loadAttributes: function ($event) {
                      return _vm.$emit("loadAttributes", $event)
                    },
                    toggleErrorsLayerVisibility: function ($event) {
                      return _vm.$emit("toggleErrorsLayerVisibility")
                    },
                    toggleLayers: function ($event) {
                      return _vm.toggleDRTLayers()
                    },
                    toggleLayerVisibility: function ($event) {
                      return _vm.$emit("toggleLayerVisibility", $event)
                    },
                    toTopOfList: function ($event) {
                      return _vm.$emit("toTopOfList", $event)
                    },
                    updateZoomEnded: function ($event) {
                      return _vm.$emit("updateZoomEnded", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("MMP_LayerFilterModal", {
              attrs: {
                filter_layer: _vm.filter_layer,
                generateCQLObj: _vm.generateCQLObj,
                isErrorsLayer: _vm.isErrorsLayer,
                layerProperties: _vm.layerProperties,
                map: _vm.map,
                mmp_layersObj: _vm.mmp_layersObj,
                selectedElement: _vm.selectedElement,
                user: _vm.user,
                zoomLevelCap: _vm.zoomLevelCap,
                selectedExtent: _vm.selectedExtent,
              },
              on: {
                filterClassesObjChanged: function ($event) {
                  _vm.filterClassesObj = $event
                },
                rulesChanged: function ($event) {
                  _vm.rules = $event
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }